// extracted by mini-css-extract-plugin
export var changeIcon = "_48-4";
export var container = "_48-0";
export var divider = "_48-7";
export var externalLinkIcon = "_48-1";
export var green = "_48-5";
export var helpCircleIcon = "_48-3";
export var iconButton = "_48-2";
export var red = "_48-6";